import * as ACTION_TYPES from './actiontypes';

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SHOW_LOADING: {
      const { payload: { statusMessage } } = action;

      return {
        ...state,
        isLoading: true,
        statusMessage
      };
    }

    case ACTION_TYPES.HIDE_LOADING: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.INIT_REQUEST: {
      return {
        ...state,
        statusMessage: 'Initializing page',
        isLoading: true
      };
    }

    case ACTION_TYPES.INIT_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        statusMessage: '',
        isLoading: false,
        details: { ...payload }
      };
    }

    case ACTION_TYPES.INIT_FAILURE: {
      return {
        ...state,
        statusMessage: '',
        isLoading: false
      };
    }

    default: {
      throw Error('usePopoutCard reducer should NEVER hit default case');
    }
  }
};

export default reducer;
